import { Pipe, PipeTransform } from '@angular/core';

/**
 * プルダウンの選択肢の一覧の幅（px）。一番長い選択肢（14px）＋左右の余白20px＋チェックマーク34px（＋スクロールバー17px）が
 * 1行に収まる幅で固定する（選んだ項目によって幅が変わらないよう、選択肢から計算した固定値にする）。本体より狭くはしない。
 * 純粋パイプのため、選択肢の一覧（配列）が変わったときだけ計算し直す。
 *
 * 使い方: [panelWidth]="items | optionPanelWidth : 230"
 *         選択肢の名前が name 以外の項目のとき: [panelWidth]="items | optionPanelWidth : 296 : 'label'"
 */
@Pipe({
  name: 'optionPanelWidth',
  standalone: true,
})
export class OptionPanelWidthPipe implements PipeTransform {

  transform(items: Record<string, any>[] | null | undefined, triggerWidth: number, nameKey = 'name'): number {
    const list = items ?? [];
    const textWidth = Math.max(0, ...list.map(i =>
      [...String(i[nameKey] ?? '')].reduce((w, c) => w + (c.charCodeAt(0) > 0xff ? 14 : 8), 0)));
    const scrollbar = list.length > 6 ? 17 : 0;
    return Math.max(triggerWidth, Math.ceil(textWidth + 20 + 34 + scrollbar));
  }
}
